import { render, staticRenderFns } from "./jobFull.vue?vue&type=template&id=b918fbc2&scoped=true"
import script from "./jobFull.vue?vue&type=script&lang=js"
export * from "./jobFull.vue?vue&type=script&lang=js"
import style0 from "./jobFull.vue?vue&type=style&index=0&id=b918fbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b918fbc2",
  null
  
)

export default component.exports